import { Button, message } from 'antd';
import { FC } from 'react';

import { logout } from '@auth';

import * as S from './styled';

/**
 * Shown when Keycloak authenticated the user but the backend will not act on the identity — there is
 * no backoffice user linked to it, its email is unverified, or the token came from a client or
 * service account that cannot act as a user.
 *
 * Deliberately a dead end rather than a redirect: the realm session is valid, so sending them back
 * to Keycloak would log them straight in again and fail the same way. Only someone internal can
 * link the account.
 */
const AccountNotLinked: FC = () => {
  // Logging out is the only thing this page offers, so a rejected logout has to say so rather than
  // leave a button that looks broken. Local caches are already cleared by then; only the realm
  // session is left, which is what a retry goes after.
  const handleLogout = () =>
    logout().catch(() =>
      message.error('Could not log out. Please try again.')
    );

  return (
    <S.Wrapper align="center" justify="center" gap={24} vertical>
      <S.Title>Your account isn’t set up yet</S.Title>
      <S.Description>
        You signed in successfully, but this identity isn’t linked to an EasyBiz
        backoffice account. Ask an administrator to set it up, then sign in again.
      </S.Description>

      <Button type="primary" size="large" onClick={handleLogout}>
        Log out
      </Button>
    </S.Wrapper>
  );
};

export default AccountNotLinked;
